import React from 'react';
import ParadigmaTable from '../../components/ParadigmaTable/ParadigmaTable';
import api from '../../api/api';
import Modal from './Modal';

const columnsCategoria = [
    {
        Header: "id",
        id: "id",
        accessor: "id",
        width: 100,
        show: false,
        private: true,
    },
    {
        Header: "Nombre",
        id: "nombre",
        accessor: "nombre",
        show: true,
    },
    {
        Header: "Visible",
        id: "show",
        accessor: d => d.show ? "SI" : "NO",
        show: true,
    },
];

const buttons = [
    {
        create: true,
        component: (props) => <Modal {...props} action="CREATE" />,
        // permission: 'plantillas_new',
    },
    {
        edit: true,
        component: (props) => <Modal {...props} action="EDIT" />,
        // permission: 'plantillas_edit',
    },
    {
        edit: true,
        component: (props) => <Modal {...props} action="DETAIL" />,
        // permission: 'plantillas_detail',
    },
    {
        delete: true,
        component: (props) => <Modal {...props} action="DELETE" />,
        // permission: 'plantillas_delete',
    }
];

const CategoriasTable = (props) =>  {

        const { modernTheme } = props;

        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={buttons}
                apiUrl={api.categorias}
                columns={columnsCategoria}
                title={"Categorías"}
            />
        );
    
}

export default CategoriasTable;


// WEBPACK FOOTER //
// ./src/views/Categorias/Categorias.js